import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RawMaterialsTableData } from "./types";

interface RawMaterialsState {
  rawMaterialsTableData: RawMaterialsTableData
  rawMaterialsIsLoading: boolean
  rawMaterialsHasError: boolean
}

export const SLICE_NAME = "rawMaterials";

const initialState: RawMaterialsState = {
  rawMaterialsTableData: {
    tabs: [],
    header_table_columns: [],
    table_data: {}
  },
  rawMaterialsIsLoading: false,
  rawMaterialsHasError: false,
};

export const rawMaterialsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getRawMaterials: state => {
      state.rawMaterialsIsLoading = true;
    },
    getRawMaterialsSuccess: (state, action: PayloadAction<RawMaterialsTableData>) => {
      state.rawMaterialsTableData = action.payload;
      state.rawMaterialsIsLoading = false;
    },
    getRawMaterialsError: state => {
      state.rawMaterialsHasError = true;
      state.rawMaterialsIsLoading = false;
    },
  },
});

export const { getRawMaterials, getRawMaterialsSuccess, getRawMaterialsError } = rawMaterialsSlice.actions;

export default rawMaterialsSlice.reducer;

